module.exports = {
	"order": {
		"mass_update": {
			"action": "Action",
			"reason": "Reason",
			"comment": "Comment",
			"left": "Left",
			"failed": "Failed"
		},
		"action": {
			"blank": "Comment",
			"payout": "Payout now",
			"payoutAtTime": "Payout at time",
			"reject": "Reject",
			"repay": "Repay",
			"refund": "Request refund",
			"declareRefund": "Declare processed refund",
			"redeposit": "Create a repeat deposit",
			"decreasePayout": "Decrease a payout amount",
			"changeAmount": "Change amount",
			"action_success": "Action is successfully completed",
			"banSavedPurse": "Ban saved purse",
			"unbanSavedPurse": "Unban saved purse",
			"cancel": "Cancel in processor"
		},
		"agree": {
			"repay": "I am sure that the payment didn't go to processing",
			"refund": "I am sure that I want to refund",
			"redeposit": "I am sure that I want to re-deposit",
			"decreasePayout": "I am sure that the customer received a smaller amount than requested",
			"changeAmount": "I am sure that I want to change the order amount",
			"declareRefund": "I am sure that I want to proceed with the refund"
		},
		"rejectAll": "Reject all customer's orders",
		"title": "Orders",
		"order": "Order",
		"download": "Download",
		"information": {
			"title": "Information",
			"order_details": {
				"title": "Order details",
				"id": "Order ID",
				"project": "Project",
				"jurisdiction": "Jurisdiction",
				"customer_country": "Customer's country",
				"type": "Type",
				"amount": "Amount",
				"billing_amount": "Billing amount",
				"refundable_amount": "Refundable amount",
				"refunds_amount": "Refunds amount",
				"billing_type": "Billing type",
				"processor": "Processor",
				"processor_channel": "Processor channel",
				"system": "System",
				"bank": "Bank",
				"purse": "Purse",
				"processor_fee": "Processor fee (calculated)",
				"subprocessor_fee": "Subprocessor fee (calculated)",
				"processor_fee_external": "Processor fee (external)",
				"project_fee": "Project fee",
				"customer_fee": "Customer fee",
				"personal_fee": "Personal fee",
				"status": "Status",
				"payout_bank": "Payout bank",
				"payout_bank_placeholder": "Select the bank that paid this order",
				"error_type": "Error type",
				"failure_code": "Failure code",
				"failure_type": "Failure type",
				"failure_kind": "Failure kind",
				"support_status": "Support status",
				"rejection_reason": "Rejection reason",
				"status_updated_at": "Status updated at",
				"transaction_id": "Transaction ID",
				"secondary_txids": "Secondary transaction IDs",
				"created_at": "Created at",
				"updated_at": "Updated at",
				"scheduled_at": "Scheduled at",
				"refcode": "Refcode",
				"processor_account": "Processor account",
				"processed_at": "Processed at",
				"three_ds_status": "3DS status",
				"three_ds_liability_shift": "3DS liability shift",
				"three_ds_challenge_indicator": "3DS challenge indicator",
				"deposit_number": "Deposit number",
				"purse_country": "Purse country",
				"rrn": "RRN",
				"tags": "Tags"
			},
			"three_ds_eci": {
				"00": "3DS authentication either failed or could not be attempted.",
				"01": "3DS authentication was processed by a stand-in service, and is classed as successful.",
				"02": "3DS authentication was successful, transaction is secured by 3DS.",
				"04": "Frictionless authentication via the Mastercard Identity Check Data Only service.",
				"05": "3DS authentication was successful, transaction is secured by 3DS.",
				"06": "Mastercard: Transaction is out of scope or exempt from SCA.\nOther: 3DS authentication was processed by a stand-in service, and is classed as successful.\n",
				"07": "Mastercard: 3DS authentication was successful; recurring transaction secured by 3DS.\nOther: 3DS authentication was processed successfully using an SCA exemption, failed, or could not be attempted.\n"
			},
			"processor_details": {
				"title": "Processor details"
			},
			"purse_details": {
				"title": "Purse details"
			},
			"token_details": {
				"title": "Session details",
				"guid": "GUID",
				"locale": "Locale",
				"country": "Country by IP",
				"mobile": "Mobile",
				"browser": "Browser",
				"user_agent": "User agent",
				"browser_engine": "Engine",
				"widget_type": "Widget type",
				"app_type": "Application type",
				"device_type": "Device type",
				"os_type": "OS type",
				"os": "OS",
				"widget_origin": "Widget origin",
				"vwo_variations": "VWO variations",
				"tracking_id": "Tracking ID",
				"source": "Source",
				"open_time": "Cashier open time"
			},
			"order_comments": {
				"title": "Order comments"
			},
			"customer_comments": {
				"title": "Customer comments"
			},
			"customer_details": {
				"title": "Customer details"
			},
			"customer_limits": {
				"title": "Customer limits"
			},
			"customer_personal_details": {
				"title": "Customer personal details"
			},
			"three_ds": {
				"title": "3DS"
			},
			"fees": {
				"title": "Fees"
			},
			"bin": {
				"title": "BIN data",
				"brand": "Brand",
				"issuer": "Bank-issuer",
				"type": "Type",
				"level": "Level",
				"prepaid": "Prepaid",
				"business": "Business",
				"country": "Country",
				"website": "Bank website",
				"phone": "Phone",
				"add_info": "Add. info"
			}
		},
		"action_logs": {
			"title": "Action logs",
			"user": "User",
			"type": "Type",
			"action": "Action",
			"date": "Date"
		},
		"tech_logs": {
			"title": "Technical logs",
			"types": {
				"project_request": "Project requests",
				"processor_request": "Processor requests",
				"callback": "Callbacks",
				"return": "Returns",
				"widget_response": "Widget responses",
				"widget_log": "Widget logs"
			}
		},
		"status_history": {
			"title": "Status history",
			"old_status": "Old status",
			"new_status": "New status",
			"change_interval": "Time to change status",
			"user": "User",
			"changed_at": "Status change date",
			"order_created_at": "Order creation date"
		},
		"subtype_history": {
			"title": "Subtype history",
			"old_subtype": "Old subtype",
			"new_subtype": "New subtype",
			"reasons": "Change reasons",
			"changed_at": "Change date"
		},
		"operations": {
			"title": "Operations",
			"id": "Operation ID",
			"guid": "Operation GUID",
			"txid": "Transaction ID",
			"status": "Status",
			"createdAt": "Created at",
			"updatedAt": "Updated at",
			"amount": "Operation amount",
			"type": "Type",
			"types": {
				"deposit": "Deposit",
				"withdraw": "Withdraw",
				"cancel": "Cancel",
				"refund": "Refund",
				"refund_auto": "Refund (auto)",
				"refund_manual": "Refund (manual)",
				"refund_backoffice": "Refund (backoffice)",
				"refund_test_widget": "Refund (test widget)",
				"refund_bank_transfer": "Refund (bank transfer)",
				"refund_other": "Refund (other)"
			},
			"statusUpdatedAt": "Status updated at"
		},
		"external_operations": {
			"title": "External operations",
			"operation_id": "Operation ID",
			"guid": "GUID",
			"type": "Type",
			"types": {
				"external_3ds": "External 3DS",
				"authorization": "Authorization",
				"payout": "Payout",
				"void": "Void",
				"capture": "Capture",
				"refund": "Refund"
			},
			"cascade_number": "Cascade number",
			"attempt_number": "Attempt number",
			"status": "Status",
			"amount": "Amount",
			"provider": "Provider",
			"provider_amount": "Provider Amount",
			"provider_fee": "Provider Fee",
			"provider_reference": "Provider Reference",
			"decline_info": "Decline info",
			"three_ds_info": "3DS info",
			"decline_info_fields": {
				"reason": "Reason",
				"type": "Type",
				"code": "Code",
				"message": "Message"
			},
			"three_ds_info_fields": {
				"eci": "ECI",
				"offered": "Offered",
				"auth_response": "Auth response",
				"version": "Version",
				"flow": "Flow",
				"liability_shift": "Liability shift",
				"challenge_indicator": "Challenge indicator"
			},
			"created_at": "Created at",
			"status_updated_at": "Status updated at"
		},
		"billing_types": {
			"normal": "Normal",
			"free": "Free",
			"test": "Test",
			"internal": "Internal"
		},
		"player": "Player",
		"type": "Type",
		"processor": "Processor",
		"payment_system": "System",
		"purse": "Purse",
		"amount": "Amount",
		"status": "Status",
		"created_at": "Created at",
		"status_updated_at": "Status updated at",
		"total": "Total",
		"support_status": {
			"title": "Support status",
			"payable": "Payable",
			"not_payable": "Not payable"
		},
		"failure_types": {
			"insufficient_funds": "Insufficient funds",
			"processor_decline": "Processor decline",
			"user_failure": "User failure",
			"timeout": "Timeout",
			"terminal": "Terminal failure"
		},
		"refund_reason": "Refund reason",
		"refund_reasons": {
			"third_party_multiaccount": "3rd party/Multiaccount",
			"minor": "Minor",
			"deposit_limit_exceeded": "Deposit limit exceeded",
			"fake_details": "Fake details",
			"banned_saved_purse": "Deposit using banned saved purse",
			"financial_gaming_fraud": "Financial fraud/Gaming fraud",
			"bug": "Bug",
			"account_blocked": "Acc blocked/closed",
			"responsible_gaming": "RG",
			"business_card": "Business card",
			"other": "Other reason"
		},
		"rejection_reasons": {
			"balance": "Insufficient balance",
			"purse": "Wrong purse",
			"support_request": "Support request",
			"banned_customer": "Banned customer",
			"old_payout": "Expired payout",
			"other": "Other",
			"banned_purse": "Banned purse"
		},
		"bank": "Bank",
		"billing_amount": "Billing amount",
		"billing_currency": "Billing currency",
		"billing_type": "Billing type",
		"customer_country": "Customer's country",
		"customer_fee": "Customer fee",
		"project_fee": "Project fee",
		"personal_fee": "Personal fee",
		"failure_code": "Failure code",
		"failure_type": "Failure type",
		"order_currency": "Order currency",
		"id": "Order ID",
		"jurisdiction": "Jurisdiction",
		"locale": "Locale",
		"platform": "Platform",
		"processed_at": "Processed at",
		"processor_channel": "Processor channel",
		"processor_fee": "Processor fee (calculated)",
		"subprocessor_fee": "Subprocessor fee (calculated)",
		"processor_fee_external": "Processor fee (external)",
		"project_name": "Project",
		"refcode": "Refcode",
		"rejection_reason": "Rejection reason",
		"scheduled_at": "Scheduled at",
		"secondary_txids": "Secondary transaction IDs",
		"token_country": "Country by IP",
		"transaction_id": "Transaction ID",
		"updated_at": "Updated at",
		"user": "User",
		"send": "Send",
		"processor_account_title": "Processor account",
		"deposit_number": "Deposit number",
		"purse_country": "Purse country",
		"banSavedPurse": {
			"customer": "Customer",
			"global": "Global",
			"type": "Type",
			"reason": "Reason",
			"cross_brand_accounts": "Cross brand accounts"
		},
		"card_type": "Card type",
		"three_ds_status": "3DS status",
		"three_ds_eci": "3DS ECI",
		"three_ds_flow": "3DS flow",
		"three_ds_liability_shift": "3DS liability shift",
		"three_ds_challenge_indicator": "3DS challenge indicator",
		"widget_type": "Widget type",
		"os_type": "OS type",
		"user_agent": "User agent",
		"vwo_variations": "VWO variations",
		"tracking_id": "Tracking ID",
		"widget_origin": "Widget origin",
		"amount_filter_tooltip": "For USD, the order amount is converted to USD. For other currencies, only orders in the specified currency are selected.",
		"rrn": "RRN",
		"tags": "Tags",
		"payout_delay_reasons": "Payout delay reasons",
		"declare_refund_type": "Refund type",
		"failure_category": "Failure category",
		"failure_responsibility": "Failure responsibility",
		"failure_kind": "Failure kind",
		"rfd_groups": "RFD groups",
		"requested_at": "Requested at",
		"deposit_segment": "Deposit segment"
	}
};